document.addEventListener("DOMContentLoaded", function () {

    /*const amazonPrimeContainerMobiles = document.querySelector('.amazon-prime-button-mobile');*/
    const amazonPrimeContainers = document.querySelector('.amazon-prime-button');

    const variantButtons = document.querySelectorAll(".js-variant-button");
    const rightbarPrice = document.querySelector(".js-rightbar-price");
    const stickyPrice = document.querySelector(".js-sticky-price");
    const stickyStrikePrice = document.querySelector(".js-sticky-strike-price");
    const rightbarStrikePrice = document.querySelector(".js-rightbar-strike-price");
    const mobileBtn = document.querySelector(".js-mobile-add-to-cart");
    const variantInputs = document.querySelectorAll(".form-id-input");
    const rightbarTitle = document.querySelector(".js-rightbar-title");
    const stickyTitle = document.querySelector(".js-sticky-title");

    const desktopForm = document.querySelector(".add-to-cart-form");
    const mobileForm = document.querySelector(".add-to-cart-form-mobile");

  const m = document.getElementById('membership-data');
  const membershipVariantId = m?.dataset.variantId || "";
  const membershipSellingPlanId = m?.dataset.sellingPlanId || "";

    const quantityContainers = document.querySelectorAll(".BuildItemQuantity");
    const addToCartFormBuildBundle = document.querySelector('.add-to-cart-form');
    const addToCartMobileFormBuildBundle = document.querySelector('.add-to-cart-form-mobile');


    variantButtons.forEach(button => {
        button.addEventListener("click", function () {

            const variantIdProduct = this.getAttribute("data-product-id");


            const url = new URL(window.location.href);
            url.searchParams.set("variant", variantIdProduct);
            window.history.replaceState({}, '', url.toString());


            const productType = this.getAttribute("data-product-type");
            const includesMembership = productType.indexOf("bundle") !== -1;

            if (productType === "mlm-single") {
                if (amazonPrimeContainers) {
                    amazonPrimeContainers.style.display = "block";
                }


                document.querySelectorAll(".mlm-single").forEach(el => {
                    el.style.display = "block";
                });
                document.querySelectorAll(".mlm-bundle").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-bundle").forEach(el => {
                    el.style.display = "none";
                });
            } else if (productType === "mlm-bundle") {
                if (amazonPrimeContainers) {
                    amazonPrimeContainers.style.display = "none";
                }


                document.querySelectorAll(".mlm-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".mlm-bundle").forEach(el => {
                    el.style.display = "block";
                });
                document.querySelectorAll(".refurb-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-bundle").forEach(el => {
                    el.style.display = "none";
                });
            } else if (productType === "refurb-single") {
                if (amazonPrimeContainers) {
                    amazonPrimeContainers.style.display = "none";
                }


                document.querySelectorAll(".mlm-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".mlm-bundle").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-single").forEach(el => {
                    el.style.display = "block";
                });
                document.querySelectorAll(".refurb-bundle").forEach(el => {
                    el.style.display = "none";
                });
            } else if (productType === "refurb-bundle") {
                if (amazonPrimeContainers) {
                    amazonPrimeContainers.style.display = "none";
                }


                document.querySelectorAll(".mlm-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".mlm-bundle").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-single").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(".refurb-bundle").forEach(el => {
                    el.style.display = "block";
                });
            }


            if (includesMembership) {
                document.querySelectorAll(".ProductDescriptionSingle").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(`.ProductDescriptionSingle[data-variant="bundle"]`).forEach(el => {
                    el.style.display = "block";
                });
            } else {
                document.querySelectorAll(".ProductDescriptionSingle").forEach(el => {
                    el.style.display = "none";
                });
                document.querySelectorAll(`.ProductDescriptionSingle[data-variant="single"]`).forEach(el => {
                    el.style.display = "block";
                });
            }

            variantButtons.forEach(btn => btn.classList.remove("active"));
            this.classList.add("active");

            const basePrice = parseInt(this.getAttribute("data-price")) || 0;
            const totalPrice = basePrice;
            const priceFormatted = (totalPrice / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });

            const variantId = this.getAttribute("data-product-id");
            const variantTitleText = this.getAttribute("data-title");


            const strikePriceRaw = this.getAttribute("data-strike-price");
            if (strikePriceRaw && parseInt(strikePriceRaw) > 0) {
                const strikeFormatted = (parseInt(strikePriceRaw) / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
                if (stickyStrikePrice) stickyStrikePrice.textContent = strikeFormatted;
                if (rightbarStrikePrice) rightbarStrikePrice.textContent = strikeFormatted;
            } else {
                if (stickyStrikePrice) stickyStrikePrice.textContent = "";
                if (rightbarStrikePrice) rightbarStrikePrice.textContent = "";
            }

            if (rightbarPrice) rightbarPrice.textContent = priceFormatted;
            if (stickyPrice) stickyPrice.textContent = priceFormatted;
            if (mobileBtn) mobileBtn.innerHTML = `ADD TO CART - ${priceFormatted}`;
            if (rightbarTitle) rightbarTitle.textContent = variantTitleText;
            if (stickyTitle) stickyTitle.textContent = variantTitleText;
            variantInputs.forEach(input => input.value = variantId);

            updateMembershipInputs(desktopForm, includesMembership, membershipVariantId, membershipSellingPlanId);
            updateMembershipInputs(mobileForm, includesMembership, membershipVariantId, membershipSellingPlanId);
            updatePricesAndCart();
        });
    });


    quantityContainers.forEach(container => {
        const decreaseButton = container.querySelector(".QuantityButton#decrease");
        const increaseButton = container.querySelector(".QuantityButton#increase");
        const quantityValue = container.querySelector(".QuantityValue");
        const minusIcon = decreaseButton.querySelector("g");

        const checkbox = container.closest('.BuildYourBundleItem').querySelector('.BuildYourBundleCheck');

        let quantity = 0;

        decreaseButton.addEventListener("click", function () {
            if (quantity > 0) {
                quantity--;
                quantityValue.textContent = quantity;

                if (quantity === 0) {
                    decreaseButton.disabled = true;
                    minusIcon.setAttribute("opacity", "0.4");
                    amazonPrimeContainers.style.display = "block";
                    checkbox.checked = false;
                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });

        increaseButton.addEventListener("click", function () {
            quantity++;
            quantityValue.textContent = quantity;

            if (quantity > 0) {
                decreaseButton.disabled = false;
                minusIcon.setAttribute("opacity", "1");

                if (!checkbox.checked) {
                    if (amazonPrimeContainers) {
                        amazonPrimeContainers.style.display = "none";
                    }

                    checkbox.checked = true;
                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });

        checkbox.addEventListener("change", function () {
            if (checkbox.checked) {

                if (quantity === 0) {
                    if (amazonPrimeContainers) {
                        amazonPrimeContainers.style.display = "none";
                    }

                    quantity = 1;
                    quantityValue.textContent = quantity;
                    decreaseButton.disabled = false;
                    minusIcon.setAttribute("opacity", "1");
                    if (amazonPrimeContainers) {
                        amazonPrimeContainers.style.display = "none";

                    }
                }
            } else {
                if (amazonPrimeContainers) {
                    amazonPrimeContainers.style.display = "block";
                }

                quantity = 0;
                quantityValue.textContent = quantity;
                decreaseButton.disabled = true;
                minusIcon.setAttribute("opacity", "0.4");
            }
            updatePricesAndCart();
        });
    });


    const checkboxes = document.querySelectorAll('.BuildYourBundleCheck');
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            if (this.checked) {
                amazonPrimeContainers.style.display = "none";
            } else {
                amazonPrimeContainers.style.display = "block";
            }
        });
    });

    function updatePricesAndCart() {
        const activeVariant = document.querySelector('.js-variant-button.active');
        const basePrice = parseInt(activeVariant.getAttribute('data-price')) || 0;
        const baseStrikePrice = parseInt(activeVariant.getAttribute('data-strike-price')) || 0;

        let bundleTotal = 0;

        document.querySelectorAll('.BuildYourBundleItem').forEach(item => {
            const checkbox = item.querySelector('.BuildYourBundleCheck');
            const quantity = parseInt(item.querySelector('.QuantityValue').textContent);
            const priceDollars = parseFloat(item.getAttribute('data-price')); // 69.99

            if (checkbox && checkbox.checked && quantity > 0) {
                const priceCents = Math.round(priceDollars * 100);
                bundleTotal += priceCents * quantity;
            }
        });

        const finalTotalCents = basePrice + bundleTotal;
        const finalStrikeCents = baseStrikePrice > 0 ? baseStrikePrice + bundleTotal : 0;

        const formattedPrice = (finalTotalCents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        const formattedStrike = (finalStrikeCents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        const rightbarPrice = document.querySelector(".js-rightbar-price");
        const stickyPrice = document.querySelector(".js-sticky-price");
        const mobileBtn = document.querySelector(".js-mobile-add-to-cart");

        const stickyStrike = document.querySelector(".js-sticky-strike-price");
        const rightbarStrike = document.querySelector(".js-rightbar-strike-price");

        if (rightbarPrice) rightbarPrice.textContent = formattedPrice;
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (mobileBtn) mobileBtn.innerHTML = `ADD TO CART - ${formattedPrice}`;

        if (baseStrikePrice > 0) {
            if (rightbarStrike) rightbarStrike.textContent = formattedStrike;
            if (stickyStrike) stickyStrike.textContent = formattedStrike;
        } else {
            if (rightbarStrike) rightbarStrike.textContent = "";
            if (stickyStrike) stickyStrike.textContent = "";
        }

        updateBundleInputs(desktopForm);
        updateBundleInputs(mobileForm);


    }


    function updateMembershipInputs(form, include, variantId, sellingPlanId) {
        const existingId = form.querySelector("input[name='items[1][id]']");
        const existingQty = form.querySelector("input[name='items[1][quantity]']");
        const existingSP = form.querySelector("input[name='items[1][selling_plan]']");
        if (include) {
            if (!existingId) {
                const idInput = document.createElement("input");
                idInput.type = "hidden";
                idInput.name = "items[1][id]";
                idInput.value = variantId;
                form.appendChild(idInput);
            } else {
                existingId.value = variantId;
            }
            if (!existingQty) {
                const qtyInput = document.createElement("input");
                qtyInput.type = "hidden";
                qtyInput.name = "items[1][quantity]";
                qtyInput.value = "1";
                form.appendChild(qtyInput);
            }
            if (!existingSP) {
                const spInput = document.createElement("input");
                spInput.type = "hidden";
                spInput.name = "items[1][selling_plan]";
                spInput.value = sellingPlanId;
                form.appendChild(spInput);
            } else {
                existingSP.value = sellingPlanId;
            }
        } else {
            if (existingId) existingId.remove();
            if (existingQty) existingQty.remove();
            if (existingSP) existingSP.remove();
        }
    }

    function updateBundleInputs(form) {

        const existingInputs = [...form.querySelectorAll("input[name^='items[']")];
        existingInputs.forEach(input => {
            const match = input.name.match(/^items\[(\d+)]/);
            if (match && parseInt(match[1]) >= 2) {
                input.remove();
            }
        });


        let itemIndex = 2;

        document.querySelectorAll('.BuildYourBundleItem').forEach(item => {
            const checkbox = item.querySelector('.BuildYourBundleCheck');
            const quantity = parseInt(item.querySelector('.QuantityValue').textContent);
            const variantId = item.getAttribute('data-id');

            if (checkbox && checkbox.checked && quantity > 0 && variantId) {

                const idInput = document.createElement("input");
                idInput.type = "hidden";
                idInput.name = `items[${itemIndex}][id]`;
                idInput.value = variantId;
                form.appendChild(idInput);

                const qtyInput = document.createElement("input");
                qtyInput.type = "hidden";
                qtyInput.name = `items[${itemIndex}][quantity]`;
                qtyInput.value = quantity;
                form.appendChild(qtyInput);

                itemIndex++;
            }
        });
    }


    if (variantButtons.length > 0) {
        variantButtons[0].click();
    }
});